import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
  isUpdating: false,
  isDeleting: false,
  isLoading: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.CREATE_MEMBER_TICKET:
    case actions.CREATE_ISSUED_MEMBER_TICKET:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_MEMBER_TICKET_ENDED:
    case actions.CREATE_ISSUED_MEMBER_TICKET_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.SEARCH_MEMBER_TICKETS:
    case actions.FIND_MEMBER_TICKET:
    case actions.GET_MEMBER_TICKET_STATISTICS:
    case actions.GET_ISSUED_MEMBER_TICKET_BATCHES:
    case actions.SEARCH_ISSUED_MEMBER_TICKETS:
    case actions.SEARCH_MEMBER_TICKET_TRANSACTION_RECORDS:
    case actions.SEARCH_MEMBER_TICKET_TRANSFER_RECORDS:
    case actions.SEARCH_VOUCHER_WITH_MEMBER_ID:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_MEMBER_TICKETS_ENDED:
    case actions.FIND_MEMBER_TICKET_ENDED:
    case actions.GET_MEMBER_TICKET_STATISTICS_ENDED:
    case actions.GET_ISSUED_MEMBER_TICKET_BATCHES_ENDED:
    case actions.SEARCH_ISSUED_MEMBER_TICKETS_ENDED:
    case actions.SEARCH_MEMBER_TICKET_TRANSACTION_RECORDS_ENDED:
    case actions.SEARCH_MEMBER_TICKET_TRANSFER_RECORDS_ENDED:
    case actions.SEARCH_VOUCHER_WITH_MEMBER_ID_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_MEMBER_TICKET:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_MEMBER_TICKET_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    case actions.DELETE_MEMBER_TICKETS:
    case actions.REVOKE_VOUCHER_TICKET:
      return {
        ...state,
        isDeleting: true,
      };
    case actions.DELETE_MEMBER_TICKETS_ENDED:
    case actions.REVOKE_VOUCHER_TICKET_ENDED:
      return {
        ...state,
        isDeleting: false,
      };
    case actions.SEARCH_REDEEM_RECORD_AND_TICKETS:
    case actions.SEARCH_REDEEM_RECORD_DETAILS_AND_TICKETS:
      return {
        ...state,
        isLoading: true,
      };
    case actions.SEARCH_REDEEM_RECORD_AND_TICKETS_ENDED:
    case actions.SEARCH_REDEEM_RECORD_DETAILS_AND_TICKETS_ENDED:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}
